<template>
  <div class="container-fluid">
    <input id="article-images" v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script src="../../../../assets/libs/fileuploader-2.2/jquery.fileuploader.min.js" type="text/javascript"></script>

<script>

import VueFileUploader from "./../../../../directives/VueFileUploader.js";

export default {
  name: "ArticleImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['article'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    var files = [];

    if (this.article.imageUrls !== null) {
      files = this.article.imageUrls.map(imageUrl => (
      {
          name: 'article.jpg',
          size: 1,
          type: 'image/jpg',
          file: imageUrl,
          data: {
            url: imageUrl
          }
        }
      ));
    }

    const url = process.env.VUE_APP_API +'/ArticleImages/' + this.article.articleId;

    this.galleryOptions = {
      name: 'article-images',
      extensions: ['image/*', 'video/*'],
      deletingImage: false,
      uploadUrl: url,
      deleteUrl: url,
      sortUrl: url,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>